import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ClarityService {
  private platformId = inject(PLATFORM_ID);

  setClarityTag(key: string, value: string | string[]): void {
    if (isPlatformBrowser(this.platformId) && window?.clarity) {
      window.clarity('set', key, value);
    }
  }
}
